/* LM Kategorie-Pilot — Ansicht, Raster, Filter, Sortierung, Seiten.
   Desktop-Pass 24.09.2026, Korrekturpass 24.09.2026.
   Nur fuer sections/lm-category-product-grid.liquid.

   Bis 50 Produkte rendert die Section die ganze Collection; Filter,
   Sortierung und Seiten laufen direkt ueber diese Liste.
   Mehr als 50 Produkte (data-lm-index="true"): Die Section rendert Shopifys
   Seite (paginate by 50, ohne JavaScript voll bedienbar). Hier wird dann
   einmal ?view=lm-index geladen (templates/collection.lm-index.liquid):
   alle Karten als inerte <template>-Elemente. Trefferzahl, Zaehler, Filter,
   Sortierung nach Preis und nach is_bestseller sowie die Seiten laufen danach
   ueber ALLE Produkte. Eine Karte wird erst in das Grid gesetzt, wenn sie auf
   der aktuellen Seite steht; ihre Bilder sind lazy. Shopifys Seitenleiste
   wird dann ausgeblendet (lm-js-pages). Scheitert der Index, bleibt Shopifys
   Seitenwechsel, und Filter/Sortierung werden nicht angeboten.

   Swatch-Treue: Bei aktiven Filtern bietet jede Karte nur Farben an, deren
   Produkt die GESAMTE aktive Filterkombination erfuellt (Farbe, Motivwelt,
   Verfuegbarkeit, Preis, Sale). Zeigt eine Karte nach einem Farbwechsel ein
   Produkt, das die Filter nicht erfuellt, springt sie auf ihr eigenes
   Produkt zurueck. Ohne aktive Filter bleiben alle Farben der Familie.

   Zustand steht in der URL (lm_c, lm_m, lm_z, lm_a, lm_sale, lm_min, lm_max,
   lm_sort, lm_page, lm_view, lm_grid). Ansichts- und Rasterwechsel aendern
   nur Klassen am Wurzelelement. */
(function () {
  'use strict';

  var INDEX_SID = 'lmidx';

  function listParam(params, key) {
    var value = params.get(key);
    return value ? value.split(',').filter(Boolean) : [];
  }

  function numParam(params, key) {
    var value = params.get(key);
    if (value === null || value === '') return null;
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }

  function fromCard(card, li, tpl, index) {
    var d = card.dataset;
    return {
      id: d.lmOrigin || d.productId || '',
      li: li,
      tpl: tpl,
      pos: parseInt(d.lmPos, 10) || index + 1,
      price: parseInt(d.lmPrice, 10) || 0,
      a: d.lmAvail || '',
      c: d.lmC || '|',
      m: d.lmM || '|',
      z: d.lmZ || '|',
      s: d.lmS === '1',
      b: d.lmB === '1'
    };
  }

  function init() {
    var root = document.querySelector('[data-lm-category]');
    if (!root || root.dataset.lmReady === '1') return;
    root.dataset.lmReady = '1';

    var list = root.querySelector('#product-grid');
    if (!list) return;

    var useIndex = root.dataset.lmIndex === 'true';
    var ready = !useIndex;
    var sectionId = list.dataset.id || '';
    var perPage = parseInt(root.dataset.lmPerPage, 10) || 12;
    var drawer = root.querySelector('[data-lm-drawer]');
    var pager = root.querySelector('[data-lm-pager]');
    var empty = root.querySelector('[data-lm-empty]');
    var toolbar = root.querySelector('[data-lm-toolbar]');
    var opener = root.querySelector('[data-lm-filter-open]');
    var activeBadge = root.querySelector('[data-lm-filter-active]');
    var countEls = root.querySelectorAll('[data-lm-count]');
    var showLabel = root.querySelector('[data-lm-show-label]');
    var onorderOpt = root.querySelector('[data-lm-onorder-opt]');
    var t = root.dataset;

    if (toolbar) toolbar.hidden = false;
    if (opener && useIndex) opener.disabled = true;

    var items = Array.prototype.slice.call(list.children)
      .filter(function (li) { return li.querySelector('.lm-card'); })
      .map(function (li, index) {
        return fromCard(li.querySelector('.lm-card'), li, null, index);
      });

    var params = new URLSearchParams(window.location.search);
    var startPage = numParam(params, 'lm_page');
    if (!startPage && useIndex) {
      var shopPage = numParam(params, 'page');
      if (shopPage && shopPage > 1) startPage = Math.floor(((shopPage - 1) * 50) / perPage) + 1;
    }
    var state = {
      c: listParam(params, 'lm_c'),
      m: listParam(params, 'lm_m'),
      z: listParam(params, 'lm_z'),
      a: listParam(params, 'lm_a'),
      sale: params.get('lm_sale') === '1',
      min: numParam(params, 'lm_min'),
      max: numParam(params, 'lm_max'),
      sort: params.get('lm_sort') || 'pos',
      page: startPage || 1,
      view: params.get('lm_view') === 'model' ? 'model' : 'product',
      grid: params.get('lm_grid') === '6' ? '6' : '4'
    };

    function writeState() {
      var p = new URLSearchParams(window.location.search);
      function put(key, value) {
        if (value === null || value === undefined || value === '') {
          p.delete(key);
        } else {
          p.set(key, value);
        }
      }
      if (ready) {
        put('lm_c', state.c.join(','));
        put('lm_m', state.m.join(','));
        put('lm_z', state.z.join(','));
        put('lm_a', state.a.join(','));
        put('lm_sale', state.sale ? '1' : '');
        put('lm_min', state.min === null ? '' : String(state.min));
        put('lm_max', state.max === null ? '' : String(state.max));
        put('lm_sort', state.sort === 'pos' ? '' : state.sort);
        put('lm_page', state.page > 1 ? String(state.page) : '');
        if (useIndex) p.delete('page');
      }
      put('lm_view', state.view === 'model' ? 'model' : '');
      put('lm_grid', state.grid === '6' ? '6' : '');
      var query = p.toString();
      try {
        window.history.replaceState(window.history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
      } catch (e) {
        /* Theme-Editor-Vorschau darf die URL nicht immer aendern — Zustand bleibt im Speicher. */
      }
    }

    function hasToken(field, value) {
      return field.indexOf('|' + value + '|') > -1;
    }

    function passes(item, skip) {
      if (skip !== 'c' && state.c.length && !state.c.some(function (v) { return hasToken(item.c, v); })) return false;
      if (skip !== 'm' && state.m.length && !state.m.some(function (v) { return hasToken(item.m, v); })) return false;
      if (skip !== 'z' && state.z.length && !state.z.some(function (v) { return hasToken(item.z, v); })) return false;
      if (skip !== 'a' && state.a.length && state.a.indexOf(item.a) === -1) return false;
      if (skip !== 'sale' && state.sale && !item.s) return false;
      if (skip !== 'price') {
        var euro = item.price / 100;
        if (state.min !== null && euro < state.min) return false;
        if (state.max !== null && euro > state.max) return false;
      }
      return true;
    }

    function compare(x, y) {
      /* Owner 29.09.2026: ausverkaufte Tuecher immer ganz ans Ende, bei jeder Sortierung. */
      var so = (x.a === 'soldout' ? 1 : 0) - (y.a === 'soldout' ? 1 : 0);
      if (so) return so;
      if (state.sort === 'price-asc') return (x.price - y.price) || (x.pos - y.pos);
      if (state.sort === 'price-desc') return (y.price - x.price) || (x.pos - y.pos);
      if (state.sort === 'best') return ((y.b ? 1 : 0) - (x.b ? 1 : 0)) || (x.pos - y.pos);
      return x.pos - y.pos;
    }

    function fill(template, n) {
      return String(template || '').split('{n}').join(String(n));
    }

    function activeCount() {
      return state.c.length + state.m.length + state.z.length + state.a.length + (state.sale ? 1 : 0) + (state.min !== null || state.max !== null ? 1 : 0);
    }

    /* Karte aus dem Index erst bei Bedarf einsetzen; Platzhalter-Section-ID
       des Index durch die echte ersetzen. */
    function ensureLi(item) {
      if (item.li || !item.tpl) return item.li;
      var fragment = document.importNode(item.tpl.content, true);
      var li = fragment.querySelector('li');
      if (!li) return null;
      var from = '-' + INDEX_SID + '-';
      li.querySelectorAll('[id]').forEach(function (el) {
        /* getAttribute statt el.id: im Formular ueberdeckt input name="id" die Eigenschaft form.id. */
        var id = el.getAttribute('id') || '';
        if (id.indexOf(from) > -1) el.setAttribute('id', id.split(from).join('-' + sectionId + '-'));
      });
      li.querySelectorAll('[data-section-id="' + INDEX_SID + '"]').forEach(function (el) {
        el.dataset.sectionId = sectionId;
      });
      item.li = li;
      return li;
    }

    function swatchItem(sw) {
      var d = sw.dataset;
      return {
        c: d.lmFC || '|',
        m: d.lmFM || '|',
        /* Format: Familienmitglieder teilen das Format der Karte. */
        z: (sw.closest('.lm-card') || { dataset: {} }).dataset.lmZ || '|',
        a: d.lmFA || '',
        price: parseInt(d.lmFP, 10) || 0,
        s: d.lmSale === '1'
      };
    }

    function syncSwatches(li) {
      var card = li.querySelector('.lm-card');
      if (!card) return;
      var active = activeCount() > 0;
      var shown = card.dataset.productId;
      var origin = card.dataset.lmOrigin;
      if (active && shown && origin && shown !== origin) {
        var current = card.querySelector('.lm-card__swatch-item[data-lm-pid="' + shown + '"]');
        if (!current || !passes(swatchItem(current))) {
          var back = card.querySelector('a[data-lm-swap][data-lm-product-id="' + origin + '"]');
          if (back) back.click();
        }
      }
      card.querySelectorAll('.lm-card__swatch-item[data-lm-pid]').forEach(function (sw) {
        sw.hidden = active && !passes(swatchItem(sw));
      });
    }

    function syncInputs() {
      if (!drawer) return;
      drawer.querySelectorAll('input[name="lm_c"]').forEach(function (input) { input.checked = state.c.indexOf(input.value) > -1; });
      drawer.querySelectorAll('input[name="lm_m"]').forEach(function (input) { input.checked = state.m.indexOf(input.value) > -1; });
      drawer.querySelectorAll('input[name="lm_z"]').forEach(function (input) { input.checked = state.z.indexOf(input.value) > -1; });
      drawer.querySelectorAll('input[name="lm_a"]').forEach(function (input) { input.checked = state.a.indexOf(input.value) > -1; });
      drawer.querySelectorAll('input[name="lm_sale"]').forEach(function (input) { input.checked = state.sale; });
      drawer.querySelectorAll('input[name="lm_sort"]').forEach(function (input) { input.checked = input.value === state.sort; });
      var min = drawer.querySelector('input[name="lm_min"]');
      var max = drawer.querySelector('input[name="lm_max"]');
      if (min) min.value = state.min === null ? '' : String(state.min);
      if (max) max.value = state.max === null ? '' : String(state.max);
    }

    function readInputs() {
      function checked(name) {
        return Array.prototype.slice.call(drawer.querySelectorAll('input[name="' + name + '"]:checked')).map(function (input) { return input.value; });
      }
      state.c = checked('lm_c');
      state.m = checked('lm_m');
      state.z = checked('lm_z');
      state.a = checked('lm_a');
      state.sale = checked('lm_sale').length > 0;
      var sort = checked('lm_sort');
      state.sort = sort.length ? sort[0] : 'pos';
      var min = drawer.querySelector('input[name="lm_min"]');
      var max = drawer.querySelector('input[name="lm_max"]');
      state.min = min && min.value !== '' && !isNaN(parseInt(min.value, 10)) ? parseInt(min.value, 10) : null;
      state.max = max && max.value !== '' && !isNaN(parseInt(max.value, 10)) ? parseInt(max.value, 10) : null;
    }

    function updateCounts() {
      if (onorderOpt) {
        var onorderInput = onorderOpt.querySelector('input');
        onorderOpt.hidden = !items.some(function (item) { return item.a === 'onorder'; }) && !(onorderInput && onorderInput.checked);
      }
      root.querySelectorAll('[data-lm-count-for]').forEach(function (el) {
        var parts = el.dataset.lmCountFor.split(':');
        var group = parts[0];
        var value = parts[1];
        var n = items.filter(function (item) {
          if (!passes(item, group)) return false;
          if (group === 'c') return hasToken(item.c, value);
          if (group === 'm') return hasToken(item.m, value);
          if (group === 'z') return hasToken(item.z, value);
          if (group === 'a') return item.a === value;
          if (group === 'sale') return item.s;
          return true;
        }).length;
        el.textContent = '(' + n + ')';
        var option = el.closest('.lm-f__opt');
        var input = option ? option.querySelector('input') : null;
        if (input) {
          input.disabled = n === 0 && !input.checked;
          option.classList.toggle('is-disabled', input.disabled);
        }
      });
    }

    function renderPager(pages) {
      if (!pager) return;
      pager.innerHTML = '';
      pager.hidden = pages < 2;
      if (pager.hidden) return;
      function add(label, page, current, aria, disabled) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.dataset.lmPage = String(page);
        if (aria) button.setAttribute('aria-label', aria);
        if (current) button.setAttribute('aria-current', 'page');
        if (disabled) button.disabled = true;
        pager.appendChild(button);
      }
      add('‹', state.page - 1, false, t.lmTPrev, state.page <= 1);
      for (var i = 1; i <= pages; i += 1) {
        add(String(i), i, i === state.page, fill(t.lmTPage, i), false);
      }
      add('›', state.page + 1, false, t.lmTNext, state.page >= pages);
    }

    function applyChrome() {
      root.classList.toggle('lm-view-model', state.view === 'model');
      root.classList.toggle('lm-grid-6', state.grid === '6');
      root.querySelectorAll('[data-lm-view]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.dataset.lmView === state.view ? 'true' : 'false');
      });
      root.querySelectorAll('[data-lm-grid]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.dataset.lmGrid === state.grid ? 'true' : 'false');
      });
    }

    function apply() {
      applyChrome();
      if (!ready) {
        writeState();
        return;
      }

      var matched = items.filter(function (item) { return passes(item); });
      matched.sort(compare);
      var pages = Math.max(1, Math.ceil(matched.length / perPage));
      if (state.page > pages) state.page = pages;
      if (state.page < 1) state.page = 1;
      var start = (state.page - 1) * perPage;
      var end = start + perPage;

      var fragment = document.createDocumentFragment();
      matched.forEach(function (item, index) {
        item.hit = true;
        var on = index >= start && index < end;
        if (on) ensureLi(item);
        if (item.li) {
          item.li.hidden = !on;
          fragment.appendChild(item.li);
        }
      });
      items.forEach(function (item) {
        if (!item.hit && item.li) {
          item.li.hidden = true;
          fragment.appendChild(item.li);
        }
      });
      list.appendChild(fragment);
      items.forEach(function (item) {
        if (item.hit && item.li && !item.li.hidden) syncSwatches(item.li);
        item.hit = false;
      });

      root.classList.toggle('lm-f-sale', state.sale);

      var resultText = fill(matched.length === 1 ? t.lmTResultOne : t.lmTResults, matched.length);
      countEls.forEach(function (el) { el.textContent = resultText; });
      if (showLabel) showLabel.textContent = fill(matched.length === 1 ? t.lmTShowOne : t.lmTShow, matched.length);
      var active = activeCount();
      if (activeBadge) activeBadge.textContent = active ? ' (' + active + ')' : '';
      if (empty) empty.hidden = matched.length > 0;

      updateCounts();
      renderPager(pages);
      writeState();
    }

    function indexUrl(page) {
      var u = new URL(window.location.href);
      var drop = [];
      u.searchParams.forEach(function (value, key) {
        if (key === 'page' || key === 'view' || key === 'sort_by' || key.indexOf('lm_') === 0 || key.indexOf('filter.') === 0) drop.push(key);
      });
      drop.forEach(function (key) { u.searchParams.delete(key); });
      u.searchParams.set('view', 'lm-index');
      if (page > 1) u.searchParams.set('page', String(page));
      u.hash = '';
      return u.toString();
    }

    function fetchIndexPage(page) {
      return fetch(indexUrl(page), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('lm-index ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('[data-lm-index]');
          if (!box) throw new Error('lm-index missing');
          return {
            pages: parseInt(box.dataset.lmPages, 10) || 1,
            templates: Array.prototype.slice.call(box.querySelectorAll('template[data-lm-id]'))
          };
        });
    }

    function loadIndex() {
      return fetchIndexPage(1).then(function (first) {
        var rest = [];
        for (var p = 2; p <= first.pages; p += 1) rest.push(fetchIndexPage(p));
        return Promise.all(rest).then(function (more) {
          return more.reduce(function (all, part) { return all.concat(part.templates); }, first.templates);
        });
      });
    }

    function mergeIndex(templates) {
      var byId = {};
      items.forEach(function (item) { byId[item.id] = item; });
      var all = [];
      templates.forEach(function (tpl, index) {
        var id = tpl.dataset.lmId;
        var known = byId[id];
        if (known) {
          if (all.indexOf(known) === -1) {
            known.tpl = tpl;
            all.push(known);
          }
          return;
        }
        var card = tpl.content.querySelector('.lm-card');
        if (!card) return;
        var item = fromCard(card, null, tpl, index);
        byId[id] = item;
        all.push(item);
      });
      items.forEach(function (item) {
        if (all.indexOf(item) === -1) all.push(item);
      });
      items = all;
    }

    function scrollToGrid() {
      var top = list.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function resetFilters() {
      state.c = [];
      state.m = [];
      state.z = [];
      state.a = [];
      state.sale = false;
      state.min = null;
      state.max = null;
      state.page = 1;
      syncInputs();
      apply();
    }

    root.addEventListener('click', function (event) {
      var viewButton = event.target.closest('[data-lm-view]');
      if (viewButton) {
        state.view = viewButton.dataset.lmView === 'model' ? 'model' : 'product';
        apply();
        return;
      }
      var gridButton = event.target.closest('[data-lm-grid]');
      if (gridButton) {
        state.grid = gridButton.dataset.lmGrid === '6' ? '6' : '4';
        apply();
        return;
      }
      var pageButton = event.target.closest('[data-lm-page]');
      if (pageButton && !pageButton.disabled) {
        state.page = parseInt(pageButton.dataset.lmPage, 10) || 1;
        apply();
        scrollToGrid();
        return;
      }
      if (event.target.closest('[data-lm-filter-open]') && drawer && ready) {
        syncInputs();
        if (typeof drawer.showModal === 'function') {
          drawer.showModal();
        } else {
          drawer.setAttribute('open', '');
        }
        return;
      }
      if (event.target.closest('[data-lm-filter-close]') && drawer) {
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.removeAttribute('open');
        }
        return;
      }
      if (event.target.closest('[data-lm-reset]') && ready) {
        resetFilters();
      }
    });

    if (drawer) {
      drawer.addEventListener('click', function (event) {
        if (event.target === drawer && typeof drawer.close === 'function') drawer.close();
      });
      drawer.addEventListener('close', function () {
        if (opener) opener.focus();
      });
      drawer.addEventListener('change', function () {
        readInputs();
        state.page = 1;
        apply();
      });
      drawer.addEventListener('submit', function (event) {
        event.preventDefault();
      });
    }

    syncInputs();
    apply();

    if (useIndex) {
      loadIndex().then(function (templates) {
        mergeIndex(templates);
        ready = true;
        root.classList.add('lm-js-pages');
        if (opener) opener.disabled = false;
        root.dataset.lmIndexItems = String(items.length);
        apply();
      }).catch(function () {
        root.dataset.lmIndexFailed = 'true';
        if (opener) opener.hidden = true;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();